import { Icon } from "@shared/antd/icon";
import React, { useMemo } from "react";
import flatMap from "lodash/flatMap";
import { TableAdaptive } from "./table-adaptive";
import { ExtTaskDataChild } from "../history-approver-table";
import { DicHrRole } from "../../../../cuba/entities/base/tsadv$DicHrRole";

interface NestedTaskTableProps {
  record: ExtTaskDataChild;
  columns: any[];
  isMobile: boolean;
  toggleIsOpened: (key: string) => void;
  requestStatusColor: Record<string, string>;
}

export const NestedTaskTable: React.FC<NestedTaskTableProps> = ({
                                                                  record,
                                                                  columns,
                                                                  isMobile,
                                                                  toggleIsOpened,
                                                                  requestStatusColor,
                                                                }) => {
  const flattenChilds = (nodes: ExtTaskDataChild[], parentKey: string, level: number): ExtTaskDataChild[] =>
    flatMap(nodes, (node, index) => {
      const key = `${parentKey}-${index}`;
      const current: ExtTaskDataChild = {
        ...node,
        key,
        level,
      };
      return [
        current,
        ...(node.isOpened && node.childs?.length
          ? flattenChilds(node.childs, key, level + 1)
          : []),
      ];
    });

  const indentedData = useMemo(() => {
    return flattenChilds(record.childs || [], record.key!, record.level || 1);
  }, [record]);

  const indentedColumns = useMemo(() => {
    return columns.map(col =>
      col.dataIndex === "hrRole"
        ? {
          ...col,
          render: (_: unknown, row: ExtTaskDataChild) => {
            const color = requestStatusColor[row.outcome] || "gray-300";
            const roleText = (row.hrRole as DicHrRole)?.langValue || "";
            return (
              <div className="flex items-start" title={roleText}>
                <div className={`w-1 absolute h-full left-0 top-0 rounded-sm mr-2 bg-${color}`} />
                <span>
                    {row.childs?.length > 0 && (
                      <a
                        onClick={() =>
                          toggleIsOpened(row.key)
                        }
                        style={{ marginRight: 8 }}
                      >
                        <Icon type={row.isOpened ? "caret-up" : "caret-down"} />
                      </a>
                    )}
                  {"↳".repeat(row.level || 1)} {roleText}
                  </span>
              </div>
            );
          },
        }
        : col,
    );
  }, [columns, toggleIsOpened, requestStatusColor]);

  if (!record.childs?.length) return null;

  return (
    <TableAdaptive
      columns={indentedColumns}
      dataSource={indentedData}
      pagination={false}
      isAdaptive={isMobile}
      bordered
      showHeader={false}
      rowKey="key"
    />
  );
};
